import React from 'react';
import FilterTagsAlpha from './FilterTags.alpha';
import FilterTagsLegacy from './FilterTags.legacy';

const FilterTags: React.FC = () => {
  const isAlpha = !process.env.IS_LEGACY;
  const Component = isAlpha ? FilterTagsAlpha : FilterTagsLegacy;
  return <Component />;
};

export default FilterTags;
